import React, { ChangeEvent } from "react"
import { SocialLinks } from "types/types"
import isValidLink from "utils/isValidLink"
import useT from "utils/useT"

interface Props {
  links: SocialLinks
  setLinks: (links: SocialLinks) => void
}

const SocialMediaInputs = ({ links, setLinks }: Props) => {
  const t = useT()
  function onChange(e: ChangeEvent<HTMLInputElement>) {
    setLinks({
      ...links,
      [e.target.name]: e.target.value,
    })
  }
  const inputs = [
    {
      label: "Facebook",
      name: "facebookLink",
      value: links?.facebookLink,
      placeholder: "https://www.facebook.com/yourname",
      icon: "fab fa-facebook color-facebook",
    },
    {
      label: "Twitter",
      name: "twitterLink",
      value: links?.twitterLink,
      placeholder: "https://www.twitter.com/yourname",
      icon: "fab fa-twitter color-twitter",
    },
    {
      label: "Instagram",
      name: "instaLink",
      value: links?.instaLink,
      placeholder: "https://www.instagram.com/yourname",
      icon: "fab fa-instagram color-instagram",
    },
    {
      label: "Other",
      name: "OtherLink",
      value: links?.OtherLink,
      placeholder: "https://www.example.com/",
      icon: "fa fa-globe-americas",
    },
  ]
  return (
    <div>
      {inputs.map((input) => (
        <div
          key={input.name}
          className="input-style has-borders has-icon validate-field mt-2"
        >
          <i className={input.icon} />
          <input
            type="url"
            className="form-control"
            name={input.name}
            value={input.value}
            placeholder={input.placeholder}
            onChange={onChange}
          />
          {input.value ? (
            isValidLink(input.value) ? (
              <i className="fa fa-check valid color-green-dark" />
            ) : (
              <i className="fa fa-times invalid color-red-dark" />
            )
          ) : (
            <em>({t.signup.optional})</em>
          )}
        </div>
      ))}
    </div>
  )
}

export default SocialMediaInputs
